<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small class="primary accent-4 white--text mr-2">
        {{ $t("profile.assignment.assignInstructions") }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{
        $t("profile.assignment.assignInstructions")
      }}</v-card-title>
      <v-card-text>
        <div style="display: flex; flex-direction: row">
          <v-badge
            class="mr-6 mt-4 flex-grow-1"
            overlap
            color="grey"
            :content="
              `${filteredInstructions.length}/${instructions &&
                instructions.length}`
            "
            right
          >
            <v-autocomplete
              class="flex-grow-1 pt-0"
              v-model="newInstructions"
              :items="filteredInstructions"
              required
              chips
              deletable-chips
              :item-text="(item) => itemText(item)"
              item-value="id"
              multiple
              ><template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="removeChip(data.item)"
                  @click:close="removeChip(data.item)"
                >
                  {{ itemText(data.item, 50) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-badge>
        </div>
        <div style="display: flex; flex-direction: row">
          <v-autocomplete
            class="flex-grow-1 mb-5"
            v-model="filters"
            :label="`${$t('instructions.filter.filterTags')}`"
            :items="tags"
            required
            chips
            deletable-chips
            solo
            hide-details
            :item-text="getDetailedTagText"
            multiple
            return-object
          >
            <template v-slot:item="{ item, attrs }">
              <v-list-item-action>
                <v-checkbox :input-value="attrs.inputValue"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{
                  getDetailedTagText(item)
                }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.explanation">
                  <span> {{ item.explanation }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="save" :loading="loading">{{
          $t("dialog.assign")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TagsQuery from "@/graphql/Tags.gql";
import InstructionsByIsActiveQuery from "@/graphql/queries/instruction/InstructionsByIsActive.gql";
import AssignedInstructionsQuery from "@/graphql/AssignedInstructions.gql";
import ChangeEmployeeInstructionsQuery from "@/graphql/ChangeEmployeeInstructions.gql";
import { getDetailedTagText } from "@/utils/tag";

export default {
  props: ["id", "employeeInstructions"],

  data() {
    return {
      show: false,
      newInstructions: [],
      loading: false,
      filters: [],
    };
  },

  computed: {
    filteredInstructions() {
      if (this.filters.length) {
        return this.instructions.filter(
          (i) =>
            (this.newInstructions && this.newInstructions.includes(i.id)) ||
            i.tagsGroups
              .flat()
              .map((tg) => tg.id)
              .some((tagId) => this.filters.some((f) => f.id == tagId))
        );
      }
      return this.instructions || [];
    },
  },

  methods: {
    getDetailedTagText: getDetailedTagText,

    removeChip(item) {
      const index = this.newInstructions.indexOf(item.id);
      if (index >= 0) this.newInstructions.splice(index, 1);
    },
    itemText(item, maxLength) {
      if (!item.code) return "";

      const text = `${item.code} | ${item.version.localizedFile.name || ""}`;

      if (maxLength) {
        return text.length < maxLength
          ? text
          : text.substring(0, maxLength) + "...";
      }

      return text;
    },
    hide() {
      this.show = false;
    },
    save() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ChangeEmployeeInstructionsQuery,
          variables: {
            employeeId: this.id,
            instructionIds: this.newInstructions,
          },
        })
        .then(() => {
          this.$emit("refresh");
          this.hide();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  apollo: {
    instructions: {
      query: InstructionsByIsActiveQuery,
      variables() {
        return {
          isActive: true,
        };
      },
      update(data) {
        return data.instructions.filter(
          (i) =>
            this.employeeInstructions.findIndex(
              (ei) => ei.id === i.id && !ei.isAssigned
            ) === -1 && !i.isAssigned
        );
      },
      skip() {
        return !this.show;
      },
    },
    assignedInstructions: {
      query: AssignedInstructionsQuery,
      variables() {
        return {
          employeeId: this.id,
        };
      },
      update(data) {
        this.newInstructions =
          (data.assignedInstructions &&
            data.assignedInstructions.map((ai) => ai.id)) ||
          [];
        return data.assignedInstructions;
      },
      skip() {
        return !this.show;
      },
    },
    tags: {
      query: TagsQuery,
      skip() {
        return !this.show;
      },
    },
  },
};
</script>
